import { attach } from 'effector';

import { WholesalesListResponse } from '@domains/login';

import { rootDomain } from '@stores/root';

import { ApiError } from '@api/client/errors';
import { apiWholesalesList } from '@api/methods';
import { WholesalesListPayload } from '@api/protocol';

const loginDomain = rootDomain.createDomain();

const _wholesalesListFx = loginDomain
    .createEffect<WholesalesListPayload, WholesalesListResponse, ApiError>()
    .use(apiWholesalesList);

export const wholesalesListFx = attach({ effect: _wholesalesListFx });
